// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    AutocompleteModel,
    BadgeModel,
    ProductAutocompleteItemModel,
    SessionModel,
} from "@insite/client-framework/Types/ApiModels";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";

export type xBaseTheme = BaseTheme & { helpers: any };

export interface CustomSessionModel extends SessionModel {}

export interface XBadgeModel extends BadgeModel {}

export interface XngAutocompleteModel extends AutocompleteModel {
    products: XngProductAutocompleteItemModel[] | null;
}

export interface XngProductAutocompleteItemModel extends ProductAutocompleteItemModel {
    cantBuy?: boolean;
    canAddToCart?: boolean;
    trackInventory?: boolean;
    minimumOrderQty?: number;
}

export enum FulfillmentMethod {
    Ship = "Ship",
    Pickup = "PickUp",
    PickUpToday = "PickupToday",
    PickUpScheduled = "PickupScheduled",
}
